import React from "react";
import { CheckCircle } from "lucide-react";
import Realestatecycle from "./Realestatecycle";
import Footer from "../../Home/Footer";
import Faqs from "../../Home/Faqs";
const travelLeadData = {
  heading: "Grow Your Real Estate Business with WhatsApp | ChatMitra",
  points: [
    "Sell properties faster with instant messaging.",
    "Generate leads without breaking the bank.",
    "Keep buyers hooked with smart automation.",
  ],
  buttons: [
    { text: "Get Start ", className: "bg-[#075E54] text-white hover:bg-[#076M54]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/real_estate/real_estate_1.png",
};


const realEstateFAQs = [
  {
    question: "How can WhatsApp help grow my real estate business?",
    answer: "WhatsApp can supercharge your real estate growth by connecting you directly with buyers and sellers through personalized listings and instant updates. It’s like having a virtual open house that’s always open, bringing clients right to your doorstep!"
  },
  {
    question: "Is WhatsApp secure for sharing property details?",
    answer: "Yes, WhatsApp’s end-to-end encryption keeps your property listings, contracts, and client info safe and sound. It’s like locking your real estate portfolio in a vault, so you can share confidently without any worries."
  },
  {
    question: "Can I schedule property tours using WhatsApp?",
    answer: "Absolutely! Clients can book virtual or in-person tours via WhatsApp, complete with reminders and directions. It’s like having a personal tour guide that makes scheduling as easy as sending a text."
  },
  {
    question: "How does WhatsApp generate real estate leads?",
    answer: "WhatsApp can spark new leads by sending targeted ads, sharing hot listings, and chatting with prospects in real time. It’s like casting a wide net that pulls in serious buyers and sellers effortlessly!"
  },
  {
    question: "What real estate content should I share on WhatsApp?",
    answer: "Send stunning property photos, market trends, and exclusive offers via WhatsApp. It’s a direct line to keep clients excited about their next home or investment, keeping you top of mind."
  },
  {
    question: "Can WhatsApp help close property deals faster?",
    answer: "Yes! Share contracts, negotiate terms, and finalize deals all through WhatsApp. It’s like turning a lengthy process into a quick chat, speeding up sales while keeping everyone happy."
  },
  {
    question: "How do clients feel about using WhatsApp for real estate?",
    answer: "They love it! Clients adore the speed, convenience, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making house hunting or selling feel like a breeze."
  },
  {
    question: "Can WhatsApp reduce my real estate workload?",
    answer: "Definitely! Automate responses to common questions and manage appointments via WhatsApp, freeing you up to focus on sealing the deal. It’s like having an assistant who’s always on call!"
  },
  {
    question: "How can I collect feedback on WhatsApp for real estate?",
    answer: "Send quick surveys or ask for reviews on your services and listings via WhatsApp. It’s a simple way to fine-tune your approach and show clients you value their thoughts."
  },
  {
    question: "How do I set up WhatsApp for my real estate business?",
    answer: "Get started with WhatsApp Business, create chat templates for tours and listings, and tap into tools like ChatMitra for a smooth setup. It’s an easy step to grow your real estate game!"
  },
];

const Realestate = () => {
  return (
    <>
      <section className="flex flex-col md:flex-col lg:flex-row gap-8 md:gap-12 bg-white max-w-6xl mx-auto mt-32 mb-10 px-6 sm:px-0 ">
        <div className="w-full md:w-full lg:w-1/2 text-left md:pl-8 mb-8 md:mb-0">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
            {travelLeadData.heading}
          </h1>
          <p className="text-lg text-gray-700 mb-6">
            See how WhatsApp for real estate transforms property sales with ChatMitra’s easy tools.
          </p>
          <ul className="mt-6 sm:mt-8 space-y-4 sm:space-y-6 text-lg">
            {travelLeadData.points.map((point, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="text-[#075E54] w-4 h-4 mr-2 self-center flex-shrink-0" strokeWidth={3} />
                {point}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-4 justify-left md:justify-start">
            {travelLeadData.buttons.map((button, index) => (
              <a
              key={index}
              href={button.buttonLink}
              className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
            >
              {button.text}
            </a>
            ))}
          </div>
        </div>
        <div className="w-full md:w-full lg:w-1/2 flex justify-center">
          <img
            src={travelLeadData.image}
            alt="WhatsApp for Real Estate Lead Capture"
            className="max-w-full h-auto rounded-lg border-transparent transition-all duration-500"
          />
        </div>
      </section>
      <Realestatecycle />

      <Faqs faqs={realEstateFAQs} />
      <title>Grow Your Real Estate Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Supercharge your real estate business with WhatsApp for real estate. ChatMitra helps you generate leads, speed up property sales, and engage buyers with automation." />
      <meta name="keywords" content="WhatsApp for real estate, real estate automation, property sales, WhatsApp chatbot, lead generation, ChatMitra" />
      <link rel="canonical" href="https://blog.chatmitra.com/whatsapp-for-real-estate" />
      <meta property="og:title" content="Grow Your Real Estate Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp for real estate to boost property sales, automate lead management, and connect with buyers instantly via ChatMitra." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-for-real-estate" />
      <meta property="og:type" content="website" />

      <Footer />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "WhatsApp for Real Estate",
            "provider": {
              "@type": "Organization",
              "name": "ChatMitra"
            },
            "description": "Enhance real estate sales with WhatsApp automation for lead generation, property tours, and buyer engagement."
          }
        `}
      </script>
    </>
  );
};

export default Realestate;